<template>
    <div>
        <auth></auth>
    </div>
</template>

<script>
    import Auth from '../components/Auth.vue'

    export default {
        components: {
            auth: Auth,
        },
    }
</script>
